// directives/track-click.directive.ts
import { Directive, HostListener, Input } from '@angular/core';
import { AnalyticsService } from '../services/analytics.service';

@Directive({
  selector: '[appTrackClick]'
})
export class TrackClickDirective {
  @Input() trackEvent: string = '';
  @Input() trackCategory: string = '';
  @Input() trackLabel: string = '';
  @Input() trackValue?: number;

  constructor(private analyticsService: AnalyticsService) {}

  @HostListener('click')
  onClick(): void {
    if (this.trackEvent) {
      this.analyticsService.trackEvent(this.trackEvent, {
        event_category: this.trackCategory,
        event_label: this.trackLabel,
        value: this.trackValue,
        element_type: 'button',
        page_path: window.location.pathname
      });
    }
  }
}
